export const GET_ALL_QR = "GET_ALL_QR";
export const CLEAR_ALL_QR = "CLEAR_ALL_QR";

export const QR_LOADING_START = "QR_LOADING_START";
export const QR_LOADING_END = "QR_LOADING_END";

export const SET_ERROR = "SET_ERROR";
